import { render, staticRenderFns } from "./LegacyAccounts.vue?vue&type=template&id=574ca3ff&"
import script from "./LegacyAccounts.vue?vue&type=script&lang=js&"
export * from "./LegacyAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports